import { render, staticRenderFns } from "./TrendyArt.vue?vue&type=template&id=16b318d0&scoped=true"
import script from "./TrendyArt.vue?vue&type=script&lang=js"
export * from "./TrendyArt.vue?vue&type=script&lang=js"
import style0 from "./TrendyArt.vue?vue&type=style&index=0&id=16b318d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b318d0",
  null
  
)

export default component.exports